const user = 'user';
const cms = 'cms';
const profile = 'profile';

const landingPage = '/';
const codeSubmit = `/${user}/codeSubmit/:solutionId/:contestId/:xpAmount/:isTournament?`;
const AllChallenges = `/${cms}/allChallenges`;
const contest = `/${cms}/contest/:id`;
const allContest = `/${cms}/allContests/:id`;
const result = `/${cms}/result`;
const candidateInfo = `/${cms}/candidateInfo/:accountId/:contestId`;
const aboutPage = '/about';
const contactPage = '/contact';
const membershipPage = '/membership';
const cookiesPage = '/cookies';
const policyPage = '/privacy-policy';
const faqPage = '/faq';
const challengeListPage = '/:type(challenges|exercises|freecode|courses)';
const challengeLandingPage = `${challengeListPage}/:id?`;
const freecodeExercisePage = `/exercise/:exerciseId`;
const freecodeChallengePage = `/challenge/:contestId`;
const freecodeCreatorPage = `/freecode-creator/:testId`;
const freecodeTestTrialPage = `/freecode-test-trial`;
const freecodeTestPage = `/freecode-test/:ticketId`;
const freecodeTestInspectPage = `/freecode-test-inspect/:inputId`;
const recruitmentPage = '/company';
const hackathon = '/hackathon/:id';
const hackathonMatches = '/hackathon-matches/:id';
const codeChallenge = '/codechallenge';
const notFoundPage = '/notFound';
const profilePage = `/${profile}`;
const profilePage2 = `/${profile}/:subpage(challenges|exercises|friends)?`;
const candidateFeedbackPage = '/candidateFeedback';
const statistics = '/statistics';
const achievementPage = `/${profile}/achievements`;
const loginPage = '/login';
const signupPage = '/signup';
const resetPasswordPage = '/resetpassword';
const setPasswordPage = '/setpassword/:session';
const payments = '/payments';
const paymentLandingPage = '/payment';
const subscriptionPlans = '/plans';
const handleStripeResponse = '/checkout/:transactionId/:sessionID/:paymentID/:paymentStatus';
const customTests = '/customTests';
const multichoice = '/multichoice/:ticketId';
const candidateTicketsPage = '/tickets';
const ticketSessionPage = '/session/:session';
const settings = '/settings';
const departmentSettings = '/department-settings/:departmentId';
const superadmin = '/superadmin';
const downloadReport = '/report/:id/:session';
const report = '/report/:id';
const xpPage = `/${profile}/xp`;
const redirect = '/c/:redirectValue';
const questionFeedbackPage = '/questionFeedback';
const unsubscribe = '/unsubscribe/:id';
const defaultHandler = '*';
const sendTestPage = '/send-test';

const Path = {
  landingPage,
  codeSubmit,
  AllChallenges,
  contest,
  allContest,
  result,
  candidateInfo,
  aboutPage,
  contactPage,
  membershipPage,
  cookiesPage,
  policyPage,
  faqPage,
  challengeListPage,
  challengeLandingPage,
  freecodeExercisePage,
  freecodeChallengePage,
  freecodeCreatorPage,
  freecodeTestTrialPage,
  freecodeTestPage,
  freecodeTestInspectPage,
  recruitmentPage,
  hackathon,
  hackathonMatches,
  codeChallenge,
  notFoundPage,
  profilePage,
  profilePage2,
  candidateFeedbackPage,
  statistics,
  achievementPage,
  loginPage,
  signupPage,
  resetPasswordPage,
  setPasswordPage,
  payments,
  paymentLandingPage,
  subscriptionPlans,
  handleStripeResponse,
  customTests,
  multichoice,
  candidateTicketsPage,
  ticketSessionPage,
  settings,
  departmentSettings,
  superadmin,
  report,
  downloadReport,
  xpPage,
  redirect,
  questionFeedbackPage,
  unsubscribe,
  defaultHandler,
  sendTestPage,
};

export default Path;
